<template>
  <div class="levo">
    <div class="levo__nazev-webu"></div>
    <LevoUser />
    <LevoMenu />
    <LevoMenuGame />
    <LevoDole />
       <div class="levo__dole__ilustrace"></div>
  </div>
</template>

<script>
import LevoMenu from "@/components/gameManager/levo/levoMenu.vue";
import LevoUser from "@/components/general/LevoUser.vue";
import LevoMenuGame from "@/components/gameManager/levo/levoMenuGame.vue";
import LevoDole from "@/components/gameManager/levo/LevoDole.vue";

export default {
  name: "Levo",
  components: {
    LevoMenu,
    LevoDole,
    LevoUser,
    LevoMenuGame,
  },
};
</script>
